import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import FileUploader from "../../../../components/common/fileUploader/FileUploader";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { getAllTCDocumentListAction, getTCDocumentAction, setTCDocumentAction, setUpdateTCDocumentAction } from "../../../../store/reducers/documentSlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

const ContractOdtTemplate = () => {
  const dispatch = useDispatch();
  const { contractODTTemplate, selectedDocument, isDocumentResponse } =
    useSelector((state: any) => state.document);
  const { userProfile, user } = useSelector((state: any) => state.user);
  const tenantId =
    userProfile?.tenant_id ??
    userProfile?.tenantId ??
    userProfile?.client?.tenant_id ??
    userProfile?.client?.tenantId ??
    user?.user?.tenant_id ??
    user?.user?.tenantId;
  const contractTemplates = Array.isArray(contractODTTemplate)
    ? contractODTTemplate
    : contractODTTemplate
      ? [contractODTTemplate]
      : [];
  const getTemplateVersion = (template: any) => {
    const nameVersion = template?.name
      ?.trim()
      .match(/^storage-contract-(\d+)$/)?.[1];
    const keyVersion = template?.s3key
      ?.match(/\/storage-contract\/(\d+)\.odt$/)?.[1];
    return Number(
      nameVersion ??
        keyVersion ??
        (template?.name?.trim() === "storage-contract" ? 1 : 0),
    );
  };
  const nextVersion =
    Math.max(0, ...contractTemplates.map(getTemplateVersion)) + 1;
  const newTemplateName = `storage-contract-${nextVersion}`;

  useEffect(() => {
    dispatch(getAllTCDocumentListAction());
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, []);

    useEffect(() => {
      if (selectedDocument) {
        console.log("selectedDocument", selectedDocument);
        // Open the PDF in a new tab
        window.open(selectedDocument, "_blank");
        dispatch(setTCDocumentAction(null));
      }
    }, [selectedDocument]);
  
    useEffect(() => {
      if (isDocumentResponse) {
        console.log("isDocumentResponse", isDocumentResponse);
        dispatch(setUpdateTCDocumentAction(false));
      }
    }, [isDocumentResponse]);

  console.log("contractODTTemplate",contractODTTemplate);
  const OnViewHablde = (name: string) => () => {
    dispatch(getTCDocumentAction({docName: name}));
  };

  return (
    <Box sx={{ p: 2, background:'#fff' }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Contract ODT Templates
        </Typography>
        <FileUploader
          onImageUpload={() => {}}
          accept=".odt"
          page="templates"
          showUploadButton
          odtFileName={newTemplateName}
          uploadFileName={`templates/${tenantId}/storage-contract/${nextVersion}.odt`}
          btnName="Upload New ODT Template"
        />
      </Box>
      {contractTemplates.map((template: any) => {
        const templateName = template?.name?.trim();
        const templateVersion = getTemplateVersion(template);
        const objectVersion = templateVersion || 1;

        return (
          <Box
            key={template?.doc_id ?? templateName}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              borderBottom: "1px solid #d1cfcf",
              py: 1.5,
            }}
          >
            <Typography>{templateName || "Storage Contract Template"}</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FileUploader
                onImageUpload={() => {}}
                accept=".odt"
                page="templates"
                showUploadButton
                odtFileName={templateName}
                uploadFileName={`templates/${tenantId}/storage-contract/${objectVersion}.odt`}
                btnName="Replace"
              />
              <CustomButton
                title="Download"
                onClick={OnViewHablde(templateName)}
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ContractOdtTemplate;
